import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
// import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as actions from '../action';
import * as c from '../constant';

function ArticlesContent({
  handleAddModal,
  handleRemove,
  handleEdit,
  articleId,
  showUserManagement,
  userManagementInfo,
  isLoading,
}) {
  useEffect(() => {
    if (_.isEmpty(articleId)) return;
    showUserManagement(articleId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(articleId)) return;
    showUserManagement(articleId);
  }, [articleId]);

  const mediaArr = _.get(userManagementInfo, 'included.media');

  return (
    <div className="container-fluid card-section-content">
      {isLoading && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(userManagementInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="col-8">
                  <h3 className="">Article Information</h3>
                </div>
                <div className="col-4 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(userManagementInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(userManagementInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  {/* <div className="col-4">
                    <img
                      className="w-100 rounded"
                      src={
                        !_.isObject(
                          _.get(userManagementInfo, 'attributes.photo') || ''
                        )
                          ? _.get(userManagementInfo, 'attributes.photo') ||
                            ImagePlaceholder
                          : _.get(userManagementInfo, 'photo.cdnUrl') ||
                            ImagePlaceholder
                      }
                      alt=""
                    />
                  </div> */}
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-6 p-3">
                            <label className="full-label mb-0 thumb-label">
                              Feature Banner:
                            </label>
                            {_.get(
                              userManagementInfo,
                              'attributes.is_video'
                            ) ? (
                              <div className="player-wrapper mx-2">
                                <ReactPlayer
                                  className="react-player"
                                  controls
                                  url={_.get(mediaArr, '0.attributes.url')}
                                  width="100%"
                                  height="100%"
                                />
                              </div>
                            ) : (
                              <img
                                className="thumbnail-src"
                                src={_.get(mediaArr, '0.attributes.url')}
                                alt=""
                              />
                            )}
                          </div>
                          <div className="form-input-group col-6 p-3">
                            <label className="full-label mb-0 thumb-label">
                              Thumbnail:
                            </label>
                            <img
                              className="thumbnail-src"
                              src={_.get(
                                userManagementInfo,
                                'attributes.thumbnail'
                              )}
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">Title:</label>
                            <span className="full-input">
                              {_.get(userManagementInfo, 'attributes.title') ||
                                '--'}
                            </span>
                          </div>
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">
                              Is Published:
                            </label>
                            <span className="full-input">
                              {_.get(userManagementInfo, 'attributes.is_active')
                                ? 'YES'
                                : 'NO'}
                            </span>
                          </div>

                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">Author:</label>
                            <span className="full-input">
                              {_.get(userManagementInfo, 'attributes.author') ||
                                '--'}
                            </span>
                          </div>
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">
                              Date Posted:
                            </label>
                            <span className="full-input">
                              {_.get(
                                userManagementInfo,
                                'attributes.date_posted'
                              ) || '--'}
                            </span>
                          </div>
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">
                              News Type:
                            </label>
                            <span className="full-input">
                              {_.get(
                                userManagementInfo,
                                'attributes.post_type'
                              ) || '--'}
                            </span>
                          </div>
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">
                              Is Featured
                            </label>
                            <span className="full-input">
                              {_.get(
                                userManagementInfo,
                                'attributes.is_featured'
                              )
                                ? 'YES'
                                : 'NO'}
                            </span>
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="form-input-group col-12 ">
                            <label className="full-label mb-0">Content:</label>
                            <p className="content-long">
                              {_.get(
                                userManagementInfo,
                                'attributes.content'
                              ) || '--'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

ArticlesContent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  userManagementInfo: PropTypes.instanceOf(Object).isRequired,
  articleId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  isLoading: api.loading.indexOf(c.GET_SINGLE_USER_MANAGEMENT) > -1,
  userManagementInfo: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  articleId: _.get(match, 'params.articleId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ArticlesContent);
